module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu_confirm/btn_my-order-43a99907bb06238216d95f8d73a90413.png";